import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { useSeo } from "../hooks/useSeo";
import { PageHero } from "../components/ui/PageHero";
import { CtaLink } from "../components/ui/CtaLink";
import { CtaBand } from "../components/ui/CtaBand";
import { Reveal } from "../components/ui/Reveal";
import { PROCESS_STAGES } from "../data/process";
export function Process() {
  useSeo({
    title: "Process",
    description: "How NEXORA builds your website in four stages: tell us, design & approve, build & review, launch & maintain.",
    path: "/process"
  });
  return <>
      <PageHero crumbs={[{
      label: "Process"
    }]} eyebrow="Process" title="Four stages. No guesswork." lead="Here's exactly what happens at each step — and what we'll need from you — so you always know what's next." actions={<CtaLink to="/contact" track="process_hero_start" size="lg" data-id="element-812" data-mp="8vur0mbn8t22">Start with step one <ArrowRightIcon className="h-4 w-4" data-id="element-813" data-mp="dontf3jn3paz" /></CtaLink>} data-id="element-811" data-mp="3dbm68t45jd4d" />
      <section className="shell section" data-id="element-814" data-mp="3n9j65tdw6eup">
        <ol className="relative" data-id="element-815" data-mp="3nalubtjty36x">
          <span className="absolute bottom-0 left-[11px] top-2 w-px bg-line-strong lg:left-[calc(25%-1px)]" aria-hidden data-id="element-816" data-mp="3iazinojngv08" />
          {PROCESS_STAGES.map((s, i) => <Reveal as="li" key={s.id} className="relative grid gap-6 pb-[clamp(3.5rem,6vw,8rem)] pl-12 last:pb-0 lg:grid-cols-[25%_1fr] lg:gap-0 lg:pl-0" data-id="element-817" data-mp="w2gpz2ois1i" data-mpi={i}>
              <span className="absolute left-0 top-2 h-6 w-6 rounded-full border-2 border-accent bg-ink lg:left-[calc(25%-12px)]" aria-hidden data-id="element-818" data-mp="9umt6ihnc5ha" />
              <div className="lg:pr-12" data-id="element-819" data-mp="5tb208j4jc6z">
                <p className="font-mono text-sm text-accent-soft" data-id="element-820" data-mp="jt3pzw39neb9">Stage {i + 1}</p>
                <h2 className="t-h2 mt-3" data-id="element-821" data-mp="jqzmvgd6yjc1">{s.title}</h2>
              </div>
              <div className="lg:pl-16" data-id="element-822" data-mp="ev25d6q6z6xo">
                <p className="t-lead max-w-[60ch] text-fg-2" data-id="element-823" data-mp="2lkgpu6qdmw0g">{s.detail}</p>
                <div className="mt-10 grid gap-8 md:grid-cols-2" data-id="element-824" data-mp="2lmjrjo0w6dl0">
                  <div data-id="element-825" data-mp="2gn6u69ce9o46">
                    <h3 className="t-eyebrow mb-4 text-muted" data-id="element-826" data-mp="2gnqfm0196umy">What we do</h3>
                    <ul className="border-t border-line" data-id="element-827" data-mp="kk25h1go5lxu">
                      {s.weDo.map(w => <li key={w} className="border-b border-line py-3 text-fg-2" data-id="element-828" data-mp="pilrt2z6czqq">{w}</li>)}
                    </ul>
                  </div>
                  <div className="rounded-2xl border border-accent/40 bg-accent/[0.06] p-5" data-id="element-829" data-mp="tla1fcvpqaor">
                    <h3 className="t-eyebrow mb-4 text-accent-soft" data-id="element-830" data-mp="yjjunhxvn17q">What we need from you</h3>
                    <ul className="grid gap-3" data-id="element-831" data-mp="13h3b8oi1rq2u">
                      {s.youProvide.map(y => <li key={y} className="text-fg" data-id="element-832" data-mp="18fent6zq8eor">{y}</li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </Reveal>)}
        </ol>
      </section>
      <CtaBand source="process" data-id="element-833" data-mp="1h7glwymbpivv" />
    </>;
}